import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';

import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../../service/auth.service';

import { ExamGroupService } from '../../service/exam-group.service';
import { ExamTemplateService } from '../../service/exam-template.service';
import { ExamTemplate } from '../exam-template';
import { ExamGroup } from '../../exam-group/exam-group';

@Component({
  selector: 'mc-exam-template-new',
  templateUrl: './exam-template-new.component.html'
})
export class ExamTemplateNewComponent implements OnInit {

  template: ExamTemplate = new ExamTemplate();
  examGroups: ExamGroup[];

  constructor(
    private examTemplateService: ExamTemplateService,
    private examGroupService: ExamGroupService,
    private notifService: ToastrService,
    private authService: AuthService,
    private location: Location
  ) {}

  ngOnInit() {
    this.examGroupService.getAll().subscribe(
      groups => this.examGroups = groups
    );

    this.template.user = this.authService.currentUser;
  }

  save(): void {
    if (!this.template) { return }
    this.examTemplateService.create(this.template).subscribe(
      template => {
        this.template = template;
        this.notifService.success('Procedimento adicionado');
        this.location.back();
      },
      error => this.notifService.error(error)
    );
  }

  goBack(): void {
    this.location.back();
  }
}
